/** UUIDs fixos do seed — usados na UI (cores/hints) da legenda. */
export const ACCOUNT_HEALTH_LEVEL_IDS = {
  saudavel: 'b1000001-0001-4000-8000-000000000001',
  atencao: 'b1000001-0001-4000-8000-000000000002',
  risco: 'b1000001-0001-4000-8000-000000000003',
  critico: 'b1000001-0001-4000-8000-000000000004',
} as const

export type AccountHealthLevel = {
  id: string
  label: string
  min_score: number
  max_score: number
  sort_order: number
  created_at: string | null
  updated_at: string | null
}

export type AccountHealthOption = {
  id: string
  pillar_id: string
  label: string
  emoji: string | null
  points: number
  sort_order: number
  is_active: boolean
  created_at: string | null
  updated_at: string | null
}

export type AccountHealthPillar = {
  id: string
  title: string
  question: string
  max_points: number
  sort_order: number
  is_active: boolean
  created_at: string | null
  updated_at: string | null
  options: AccountHealthOption[]
}

export type AccountHealthConfig = {
  levels: AccountHealthLevel[]
  pillars: AccountHealthPillar[]
}

export type AccountHealthLevelUpdate = {
  label?: string
  min_score?: number
  max_score?: number
  sort_order?: number
}

export type AccountHealthLevelCreate = {
  label: string
  min_score: number
  max_score: number
  sort_order: number
}

export type AccountHealthPillarUpdate = {
  title?: string
  question?: string
  max_points?: number
  is_active?: boolean
  sort_order?: number
}

export type AccountHealthPillarCreate = {
  title: string
  question: string
  max_points: number
  sort_order: number
  is_active?: boolean
}

export type AccountHealthOptionUpdate = {
  label?: string
  emoji?: string | null
  points?: number
  is_active?: boolean
  sort_order?: number
}

export type AccountHealthOptionCreate = {
  pillar_id: string
  label: string
  emoji?: string | null
  points: number
  sort_order: number
  is_active?: boolean
}
